import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, Tv, Flame } from "lucide-react";
import { liveChannels } from "../mock";

export default function LiveChannelsRow({ onSelect }) {
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * 600, behavior: "smooth" });

  return (
    <section className="max-w-[1500px] mx-auto px-6 mt-14">
      <div className="flex items-end justify-between mb-3">
        <div className="flex items-start gap-2">
          <Tv className="w-6 h-6 text-emerald-400" />
          <div>
            <div className="flex items-center gap-2 text-xs text-white/60 mb-1">
              <span>Globo RJ HD (74)</span>
              <span>•</span>
              <span>RecordTv SP H265 (24)</span>
              <span>•</span>
              <span>Discovery Channel (16)</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold tracking-tight">Canais Ao Vivo Grátis</h2>
          </div>
        </div>
        <div className="hidden md:flex gap-2">
          <button onClick={() => scroll(-1)} className="w-9 h-9 rounded-full bg-white/5 hover:bg-emerald-500/30 transition border border-white/10 flex items-center justify-center">
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
          <button onClick={() => scroll(1)} className="w-9 h-9 rounded-full bg-white/5 hover:bg-emerald-500/30 transition border border-white/10 flex items-center justify-center">
            <ChevronRight className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>

      <div ref={ref} className="no-scrollbar flex gap-4 overflow-x-auto pb-6 -mx-2 px-2">
        {liveChannels.map((c) => (
          <button
            key={c.id}
            onClick={() => onSelect(c)}
            className="movie-card relative shrink-0 w-[260px] aspect-video rounded-xl overflow-hidden bg-[#111] text-left group"
          >
            <img src={c.image} alt={c.name} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/30 to-transparent" />
            <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-1 rounded-md bg-red-600 text-white text-[10px] font-bold uppercase tracking-wide">
              <span className="w-1.5 h-1.5 rounded-full bg-white pulse-dot" /> AO VIVO
            </div>
            {c.hot && (
              <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-1 rounded-md bg-red-600 text-white text-[10px] font-bold uppercase">
                <Flame className="w-3 h-3" /> Hot
              </div>
            )}
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="text-[10px] uppercase tracking-widest text-emerald-400 font-bold">{c.category}</p>
              <p className="text-white text-base font-bold">{c.name}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
